
module.exports = {
  contentType: 'application/json;charset=UTF-8',
  requestTimeout: 500000,
  successCode: 200,
  noPermissionCode: 401,
  invalidCode: 402,
  debounce: ['doEdit'],
}
